import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Users, Clock, CheckCircle, TrendingUp, BarChart3, MousePointerClick } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
const kpis = [{
  icon: Users,
  label: 'Engagement Rate',
  description: 'Unique HCPs who interact with a Snak™ vs. total booth traffic'
}, {
  icon: Clock,
  label: 'Avg. Interaction Time',
  description: 'Time spent per HCP across all Snak™ touchpoints'
}, {
  icon: MousePointerClick,
  label: 'Completion Rate',
  description: '% of HCPs who complete a full Snak™ journey (not just start)'
}, {
  icon: TrendingUp,
  label: 'Aisle → Booth Conversion',
  description: '% of aisle-engaged HCPs who cross into the booth for a rep conversation'
}, {
  icon: CheckCircle,
  label: 'Consent Capture Rate',
  description: '% of booth visitors who opt-in for post-congress follow-up'
}, {
  icon: BarChart3,
  label: 'Topic Preference Distribution',
  description: 'Breakdown of disease areas selected — informs future content strategy'
}];
export function SlideResults() {
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-8 md:p-16 flex flex-col relative" data-id="element-622">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-10 text-center" data-id="element-623">
        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-624">
          <div className="w-8 h-[2px] bg-[#E60012]" data-id="element-625" />
          <span className="text-[#E60012] text-sm font-medium tracking-wide uppercase" data-id="element-626">
            Measurement Framework
          </span>
          <div className="w-8 h-[2px] bg-[#E60012]" data-id="element-627" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-[#2D2926] mb-4" data-id="element-628">
          KPIs We Track
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-629">
          Every Snak™ interaction is measurable. These are the key metrics we
          report on to quantify congress ROI.
        </p>
      </motion.div>

      <motion.div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-start content-center" variants={container} initial="hidden" animate="show" data-id="element-630">
        {kpis.map((kpi, index) => {
        const Icon = kpi.icon;
        return <motion.div key={index} variants={item} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex items-start gap-4 relative overflow-hidden group hover:border-[#E60012]/30 transition-colors" data-id="element-631">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#E60012] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-632" />
              <div className="w-12 h-12 rounded-full bg-[#E60012]/10 flex items-center justify-center shrink-0" data-id="element-633">
                <Icon className="w-6 h-6 text-[#E60012]" data-id="element-634" />
              </div>
              <div data-id="element-635">
                <h3 className="text-base font-bold text-[#2D2926] mb-1" data-id="element-636">
                  {kpi.label}
                </h3>
                <p className="text-sm text-gray-500 leading-snug" data-id="element-637">
                  {kpi.description}
                </p>
              </div>
            </motion.div>;
      })}
      </motion.div>
    </div>;
}